<template>
  <div class="result">


    <img alt="logo" class="print-only uk-align-right uk-margin-medium-left" src="../assets/logo.png" style="max-width:250px" width="15%">

<div id="mail">
    <h3 class="uk-margin-medium-top uk-padding-remove-top uk-text-uppercase">Preaprobación y medición de riesgo de crédito</h3>
    <p v-if="loading"> <span uk-spinner="ratio:3"></span> </p>
    
    <p>Nombre: {{name}} <br> Fecha de registro: {{date}} </p>
    <div uk-grid class="uk-child-width-1-2 uk-margin-large-top">
        <div>

    <h3 class="uk-text-uppercase"  >Resultado medición riesgo crediticio:</h3> <p  style="font-size:20px"> {{aprob}}</p>
        </div>
        <div>
      <h3 class="uk-text-uppercase">RESULTADO  Capacidad de Pago </h3>

    
      <p style="font-size:20px">
    <span >Ingreso neto: {{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(ing)}} <br>Egresos: {{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(egg)}} <br></span>
          Ahorro disponible: {{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(data['4C CAPACIDAD DE PAGO POR DATOS FINANCIEROS']['Saldo disponible'])}} 
      <br> Cuota a pagar: {{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(parseFloat(data['4C CAPACIDAD DE PAGO POR DATOS FINANCIEROS']['Cuota mensual']))}}
      <br> <b>Capacidad de pago:</b> %{{ data['4C CAPACIDAD DE PAGO POR DATOS FINANCIEROS']['Relación entre cuota y disponible']}}
      </p>
        </div>
    </div>

    <div class="uk-text-left" style="page-break-after:always">

    <h3 class="uk-text-center uk-margin-large-top">CALIFICACIÓN SCORING 7 CS <br>
    <p  :style="{'background-color':color}">{{String(total) + ' - ' + String(text)}}</p></h3>
    </div>

    <hr>
    

    <h3 class="uk-text-uppercase">Tabla de Puntajes</h3>
    <p class="uk-text-left">Analice los siguientes parámetros del cliente para entender el riesgo. Los puntajes más bajos representan posibles factores de riesgo presentes.</p>
    <table class="uk-table uk-table-striped uk-table-hover">
      <thead>
        <tr>
          <th>
            Parámetro
          </th>
          <th>
            Puntaje
          </th>
          <th>
            Máximo
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in Object.keys(data).sort()">
          <td v-if="item != 'Cédula' && item != 'act' && item != 'asalariado' && item != 'RFC' && item != 'Fecha de nacimiento' && item != 'name' && item != 'deudor'&& item != 'PUNTAJE TOTAL'&& item != 'Porcentaje'">
            {{item}}
          </td>
          <td v-if="item != 'Cédula' && item != 'act' && item != 'asalariado' && item != 'RFC' && item != 'Fecha de nacimiento' && item != 'name' && item != 'deudor'&& item != 'PUNTAJE TOTAL'&& item != 'Porcentaje'">
            {{data[item]['PUNTAJE TOTAL']}}
          </td>
          <td v-if="item != 'Cédula' && item != 'act' && item != 'asalariado' && item != 'RFC' && item != 'Fecha de nacimiento' && item != 'name' && item != 'deudor'&& item != 'PUNTAJE TOTAL'&& item != 'Porcentaje'">
             <span v-if="item == '4C CAPACIDAD DE PAGO POR DATOS FINANCIEROS'">100</span><span v-else>75</span>
          </td>
          
        </tr>
        <hr>
        <tr :style="{'background-color':color}">
          <td > 
            <b>
            PUNTAJE OBTENIDO SCORING 7CS
            </b>
          </td>
          <td > <b>{{total}}</b> </td>
        </tr>
      </tbody>
    </table>


    <hr >
    <div class="uk-text-justify print-only"  style="page-break-before:always" >  
        <h3 class="uk-text-uppercase">
          Resultados de riesgo crediticio por las 7Cs
        </h3>
        <table v-for="item in  Object.keys(data).sort()" v-if="item != 'name' && item != 'PUNTAJE TOTAL' && item != 'act' && item != 'asalariado' && item != 'deudor' && item != 'Porcentaje'" class="uk-table uk-table-striped uk-table-small">
          <th>
            <td>
              <p> <b style="font-size:18px">{{item}}</b> </p>
            </td>
          </th>
          <tr v-for="i, j in data[item]">
            <td>
              {{j}}
            </td>
            <td>
              {{i}}
            </td>
          </tr>
        </table>
    </div>

    <h3 class="uk-text-uppercase">Tabla de niveles de riesgo conforme a puntaje</h3>
    <table class="uk-table uk-table-divider uk-text-left">
      <thead>
        <tr>
          <th>
            NIVEL DE RIESGO
          </th>
          <th>
            PUNTAJE MÁXIMO
          </th>
          <th>
            PUNTAJE MÍNIMO
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            Bajo
          </td>
          <td>
            500
          </td>
          <td>
            451
          </td>
        </tr>
        <tr>
          <td>
            Moderado
          </td>
          <td>
            450
          </td>
          <td>
            401
          </td>
        </tr>
        <tr>
          <td>
            Medio
          </td>
          <td>
            400
          </td>
          <td>
            301
          </td>
        </tr>
        <tr>
          <td>
            Medio Alto
          </td>
          <td>
            300
          </td>
          <td>
            251
          </td>
        </tr>
        <tr>
          <td>
            Alto
          </td>
          <td>
            250
          </td>
          <td>
            1
          </td>
        </tr>
      </tbody>
    </table>

    <p>Tu puntaje: {{total}} <br>Porcentaje: {{((total/500)*100).toFixed(2)}}%</p>

    <p >El otorgamiento de crédito está sujeto a la veracidad de los datos dados de buena fe por el
solicitante, a la información y documentación que para cada dato se requiera, a los informes que
deban entregar las empresas autorizadas para proporcionar informes de crédito, así como la
autorización que deba emitir el comité de crédito de esta institución, por consiguiente el contenido
de la preaprobación no genera ninguna responsabilidad ni obligación a nuestro cargo por la solicitud
realizada.</p>

    </div>
    <div v-if="!fromMail">
        <div class="uk-margin no-print">
          <label >Elije el correo para enviar tu reporte</label>
          <select class="uk-select" v-model="mail">
            <option >integralcci@gmail.com</option>
            <option >appsverdes@gmail.com</option>
          </select>
        </div>

        <div class="uk-margin no-print">
          <button class="uk-button uk-button-primary uk-button-large" v-on:click="send">enviar reporte</button>
        </div>
        <p v-if="loading"><span uk-spinner="ratio:3"></span></p>
    </div>

        <div class="uk-margin no-print">
          <button class="uk-button uk-button-secondary uk-button-large" v-on:click="print">imprimir o guardar reporte</button>
        </div>
        
        <div class="uk-margin no-print">
          <button class="uk-button uk-button-primary uk-button-large" v-on:click="makecsv">Exportar a excel</button>
        </div>

        <div v-if="!fromMail" class="uk-margin no-print">
          <button class="uk-button uk-button-default uk-button-large" v-on:click="again">empezar otro análisis 7c</button>
        </div>


  </div>
</template>

<script>
export default {
    data: function() {
      return {
        data : {},
        loading : false,
        mail : '',
        now : String(new Date().getTime()),
        fromMail : false,
        asalariado:this.$score.asalariado,
        date : '',
        name: '',
        ing:0,
        egg:0,
        aprob : '',
        loading : false,
      }
    }, 
    computed: {
      total : function() {
        var tot = 0.0
        var count = 0
        for (var i in this.data){
          if(this.data[i].hasOwnProperty('PUNTAJE TOTAL')){
             tot += parseFloat(this.data[i]['PUNTAJE TOTAL'])
          }
        }
        return tot.toFixed(2)
      },
      color: function() {
        switch (true) {
          case this.total >= 451:
            return "#42f54e"

          case this.total > 401:
            return "#f5e042"

          case this.total > 301:
            return "#f5e042"

          case this.total > 251:
            return "#f59642"

          default:
            return "#f54242"
        }
      },
      text: function() {
        switch (true) {
          case this.total >= 451:
            return "BAJO RIESGO"

          case this.total > 401 :
            return "RIESGO MODERADO"

          case this.total > 301 :
            return "RIESGO MEDIO"

          case this.total > 251:
            return "RIESGO MEDIO ALTO"

          default:
            return "RIESGO ALTO"
        }
      },
    },
    mounted:async function(){
      window.scroll(0,0)
      this.loading = true
        // estas credenciales son públicas 
        // estas credenciales solo tiene acceso a la función pública del correo
        await firebase.auth().signInWithEmailAndPassword('7c@mail.com','TfXX8MjDtwUZv1UUDNXMwmYlQW12')

        if(this.$route.params.id){
          this.now = this.$route.params.id
          await firebase.database().ref('apps/7c/integral/reportes/' + this.$route.params.id).once('value').then(function (s) {
            this.data = s.toJSON()
            sessionStorage.setItem('score', JSON.stringify(this.data))
          }.bind(this))
        }
      

        this.date = new Date(parseInt(this.now)).toLocaleString()
        this.data =  JSON.parse(sessionStorage.getItem('score'))
        this.name = this.data['name']
      this.ing = this.data['4C CAPACIDAD DE PAGO POR DATOS FINANCIEROS']['Total Ingresos']
      this.egg = this.data['4C CAPACIDAD DE PAGO POR DATOS FINANCIEROS']['Total Gastos']
      this.data['4C CAPACIDAD DE PAGO POR DATOS FINANCIEROS']['Relación entre cuota y disponible'] >= 100 ? this.aprob = 'Pre Aprobado' : this.aprob = 'No puede pagar, revisar plazo o monto'


      this.data['PUNTAJE TOTAL'] = this.total
      this.data['Porcentaje'] = ((this.total/490)*100).toFixed(2)

      if(!this.$route.params.id) firebase.database().ref('apps/7c/integral/reportes/' + this.now).update(this.data)
      

        this.loading = false
      

    },
    methods:{
      send : async function() {
        if(this.data['7C CONDICIONES DEL MERCADO O ENTORNO']){
          this.loading = true

          // estas credenciales son públicas 
          // estas credenciales solo tiene acceso a la función pública del correo
          await firebase.auth().signInWithEmailAndPassword('7c@mail.com','TfXX8MjDtwUZv1UUDNXMwmYlQW12')

          if(this.mail){
            var sendMail = firebase.functions().httpsCallable('cincoc') // esta es la función del correo
            var mailData = {
              mail : this.mail,
              res : document.getElementById('mail').innerHTML 
            }
            await sendMail(mailData)
            UIkit.notification('Resultados enviados correctamente','success')
            await firebase.auth().signOut()

          } else {
            UIkit.notification('Debes ingresar una dirección de correo válida','warning')
          }


          
        } else {
          UIkit.notification('No se respondieron todas las preguntas','warning')
          // this.$router.push('/')
        }
        this.loading = false
      },
      print : function() {
        window.print()
      },
      again:function () {
        this.$score = {}
        sessionStorage.removeItem('score')
        this.$router.push('/')
      },
      makecsv: async function () {

          var csvVals = []
  
          var data = this.data

          var csvCount = 1

          var heads = ['Nombre','Fecha','Ingresos','Egresos','Actividad','Deudor','RFC']
          var res = [ this.data.name, this.date, this.ing, this.egg, this.data.act, this.data.deudor, this.data['RFC'] ]
          

          for (var i in data){
            var index = i
            if(index != 'act' && index != 'asalariado' && index != 'RFC' && index != 'Fecha de nacimiento' && index != 'name'){
              heads.push(i)
              res.push(data[i]['PUNTAJE TOTAL'])
            }
          }

          heads.push(['PUNTAJE TOTAL', 'Porcentaje'])
          res.push([this.total, ((this.total/490)*100).toFixed(2)])


          // var heads = []
          // var res = []

          // for(var i in data){
          //   console.log(typeof(data[i]));
          //   if(typeof(data[i]) == 'object') {
          //     for(var j in data[i]){
          //       if(typeof(data[i][j]) == 'object') {
          //             for(var k in data[i][j]){
          //               heads.push(k)
          //               res.push(data[i][j][k])
          //             }
          //         continue
          //       }
          //       heads.push(j)
          //       res.push(data[i][j])
          //     }
          //     continue
          //   }
          //   heads.push(i)
          //   res.push(data[i])
          // }

          csvVals.push(heads)

          csvVals.push(res)
          csvCount++

          
          let csvContent = "data:text/csv;charset=utf-8,%EF%BB%BF" 
              + encodeURI(csvVals.map(e => e.join(",")).join("\n"));

          var encodedUri = csvContent;
          var link = document.createElement("a");
          link.setAttribute("href", encodedUri);
          link.setAttribute("download", "resultado_7c.csv");
          document.body.appendChild(link); // Required for FF

          link.click(); // This will download the data file.
          
      },
    }
}
</script>
